export function trackEvent(name, payload = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...payload });
  window.dispatchEvent(new CustomEvent("jma:analytics", { detail: { name, payload } }));
}
